export function withPlatformV2OriginMarker(href: string): string {
  const [path, hash] = href.split('#');
  const separator = path.includes('?') ? '&' : '?';
  const markedPath = `${path}${separator}origin=platform-v2`;
  return hash ? `${markedPath}#${hash}` : markedPath;
}
